import { Body, Box, Button, Sheet } from '@hover/blueprint';
import React from 'react';

import {
  HomeownerAppMenuNames,
  useHomeownerAppContext,
} from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const SaveForLater = () => {
  const { setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <Sheet.Contents header={t('saveIdeas.saveForLater')}>
      <Body color="neutral.600">{t('saveIdeas.addToFavorites')}</Body>
      <Box
        flexDirection="column"
        gap={200}
        justifyContent="center"
        paddingBottom={400}
        paddingTop={400}
      >
        <Button
          label="sign-up-or-login"
          onClick={() => setCurrentMenu(HomeownerAppMenuNames.SIGN_IN)}
          textDecoration="none"
          variant="primary"
        >
          {t('saveIdeas.signUpOrLogIn')}
        </Button>
        <Button
          label="no-save"
          onClick={() => setCurrentMenu()}
          variant="ghost"
        >
          {t("saveIdeas.nodon'tSave")}
        </Button>
      </Box>
    </Sheet.Contents>
  );
};

export { SaveForLater };
